import React, { useContext } from 'react';
import { Box, Stack } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import CommonLayout from '../../_layouts/CommonLayout';
import { AppContext } from 'views/App/context';
import { Alert, Typography } from '@mui/material';
import { neutral } from '_lex/_foundations/phxColors';
import { useDashboard } from '../context';
import LexipolReportMetrics from './LexipolReportMetrics';
import LexipolReportSolutions from './LexipolReportSolutions';

export default function LexipolReportDashboard() {
  const { hasNoPermission, hasPermission, hasPermissionError, currentOrganizationId } = useContext(AppContext);
  const { tabs } = useDashboard();

  if (hasPermissionError) {
    return (
      <CommonLayout noPadding tabs={tabs}>
        <Box sx={{ px: 8, py: 10, backgroundColor: neutral[50] }}>
          <Alert severity='error' sx={{ mb: 2 }}>
            <Typography variant='body1'>
              Lexipol has encountered a problem retrieving your data, please contact Customer Support.
            </Typography>
          </Alert>
        </Box>
      </CommonLayout>
    );
  }

  if (hasNoPermission() && !hasPermissionError) {
    return (
      <CommonLayout noPadding tabs={tabs}>
        <Box sx={{ px: 8, py: 10, backgroundColor: neutral[50] }}>
          <Alert severity='warning'>
            <Typography variant='body1'>{t('dashboard.noPermissions')}</Typography>
          </Alert>
        </Box>
      </CommonLayout>
    );
  }

  if (!hasPermission('viewFieldBank', currentOrganizationId || '')) {
    return (
      <CommonLayout noPadding tabs={tabs}>
        <Box sx={{ px: 8, py: 10, backgroundColor: neutral[50] }} />
      </CommonLayout>
    );
  }

  return (
    <CommonLayout
      noPadding
      tabs={tabs}
    >
      <Box sx={{ px: 8, py: 10, backgroundColor: neutral[50] }}>
        <Box
          className='lexipol-report-dashboard'
          sx={{
            display: 'grid',
            gridTemplateColumns: '3fr 1fr',
            gap: 10,
          }}
        >
          <Stack spacing={8}>
            <LexipolReportMetrics />
          </Stack>
          <Stack spacing={8}>
            <LexipolReportSolutions />
          </Stack>
        </Box>
      </Box>
    </CommonLayout>
  );
}
